import { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import LinkCell from '../Cells/LinkCell/LinkCell';
import ActionCell from '../Cells/ActionCell/ActionCell';

import { BsTrapData } from 'api/traps/BsTraps/types';
import { Breakpoints } from 'hooks/Screen/useScreenSize';

export const useBsTrapsColumns = (slug: string): TableColumn<BsTrapData>[] => {
  const { t } = useTranslation();
  return [
    {
      name: t('TrapTables.StatusInGrams'),
      selector: row => row.bait_filling || 0,
      sortable: true,
      sortField: 'bait_filling',
      grow: 1,
    },
    {
      name: t('TrapTables.Number'),
      selector: row => row.sequence_number,
      sortable: true,
      sortField: 'sequence_number',
      hide: Breakpoints.Mobile,
      cell: row => (
        <LinkCell
          title={String(row.sequence_number) || 'None'}
          link={`/bait_trap/info/${row.slug}`}
          icon="ri-eye-line"
        />
      ),
    },
    {
      name: t('TrapTables.InteractiveMap'),
      selector: row => row.default_plan.url_ending,
      grow: 2,
      hide: Breakpoints.Tablet,
      cell: row => (
        <LinkCell
          title={row.default_plan.on_plan ? row.default_plan.title : t('TrapTables.NotOnPlan')}
          link={`/object/plan/${row.default_plan.on_plan ? 'trap/' : ''}${slug}/${row.default_plan.url_ending}`}
          icon="ri-treasure-map-line"
          is_warning={!row.default_plan.on_plan}
        />
      ),
    },
    {
      name: t('TrapTables.Action'),
      selector: row => row.serial_number,
      grow: 1,
      cell: row => (
        <ActionCell
          qrCodeOptions={{ msg: `Device Serial Number: ${row.serial_number}`, qr_code: row.qr_code }}
          trap={{ pk: row.id, serialNumber: row.serial_number }}
          slug={slug}
        />
      ),
    },
    {
      name: t('TrapTables.Type'),
      selector: row => row.trap_type,
      sortable: true,
      sortField: 'trap_type',
      grow: 0.3,
      hide: Breakpoints.Desktop,
    },
    {
      name: t('TrapTables.LastVisit'),
      selector: row =>
        dayjs(row.last_visit).isValid() ? dayjs(row.last_visit).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm') : '-',
      sortable: true,
      sortField: 'last_visit',
      hide: Breakpoints.Desktop,
    },
    {
      name: t('TrapTables.SerialNumber'),
      selector: row => row.serial_number,
      sortable: true,
      sortField: 'serial_number',
      hide: Breakpoints.LargeDesktop,
    },
    {
      name: t('TrapTables.Level'),
      selector: row => row.save_level,
      sortable: true,
      sortField: 'save_level',
      hide: Breakpoints.LargeDesktop,
    },
    {
      name: t('TrapTables.DateOfInstallation'),
      selector: row => dayjs(row.date_of_installation).format('YYYY.MM.DD'),
      sortable: true,
      sortField: 'date_of_installation',
      hide: Breakpoints.LargeDesktop,
    },
  ];
};
